import { Tooltip } from "components/Tooltip";

const QuickDetailCard = ({
  firstHeader,
  firstHeaderTooltip,
  firstValue,
  secondHeader,
  secondHeaderTooltip,
  secondValue,
}: {
  firstHeader: string;
  firstHeaderTooltip?: string;
  firstValue: string;
  secondHeader: string;
  secondHeaderTooltip?: string;
  secondValue: string;
}) => {
  const renderHeader = (header: string, tooltip?: string) => {
    const label = (
      <span className="block text-xs text-gray-500 leading-tight">
        {header}
      </span>
    );
    if (!tooltip) return <div className="mb-1">{label}</div>;
    return (
      <div className="mb-1">
        <Tooltip content={tooltip}>{label}</Tooltip>
      </div>
    );
  };

  return (
    <div className="flex items-stretch border rounded-md overflow-visible bg-white w-full min-w-0 min-h-full">
      <div className="flex flex-1 divide-x min-w-0">
        <div className="flex flex-col justify-center p-3 md:p-2 lg:p-3 xl:p-4 flex-1 min-w-0">
          {renderHeader(firstHeader, firstHeaderTooltip)}
          <span className="block text-lg md:text-xl lg:text-2xl font-semibold leading-tight">
            {firstValue}
          </span>
        </div>
        <div className="flex flex-col justify-center p-3 md:p-2 lg:p-3 xl:p-4 flex-1 min-w-0">
          {renderHeader(secondHeader, secondHeaderTooltip)}
          <span className="block text-lg md:text-xl lg:text-2xl font-semibold leading-tight">
            {secondValue}
          </span>
        </div>
      </div>
    </div>
  );
};

export default QuickDetailCard;
